import React from 'react';
import { Link } from 'react-router-dom';

const C = { primary: '#8B1A1A', gold: '#D4A017' };

export default function NotFound() {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 24px', textAlign: 'center' }}>
      <div style={{ fontSize: 80, marginBottom: 16, lineHeight: 1 }}>404</div>
      <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, color: '#2C2C2C', marginBottom: 12 }}>Page Not Found</h1>
      <p style={{ color: '#888', fontSize: 16, marginBottom: 32, maxWidth: 400 }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link to="/" style={{ background: C.primary, color: '#fff', textDecoration: 'none', padding: '12px 28px', borderRadius: 4, fontSize: 15, fontWeight: 600 }}>
          Back to Home
        </Link>
        <Link to="/shop" style={{ background: '#fff', color: C.primary, textDecoration: 'none', padding: '12px 28px', borderRadius: 4, fontSize: 15, fontWeight: 600, border: `2px solid ${C.primary}` }}>
          Browse Shop
        </Link>
      </div>
    </div>
  );
}
